export default __webpack_public_path__ + "static/media/soon.c79242bb.svg";